module.exports = __webpack_public_path__ + "img/LV48503009063.f984d62f.png";